// extracted by mini-css-extract-plugin
export default {"card":"card__H2YPRXQt","header":"header__OHblqaiI","tooltip":"tooltip__3PQkip2k","text":"text__SpNgsZtz"};